const styles = theme => ({
  rootTableCell: {
    backgroundColor: '#fff',
    width: '15%',
    textAlign: 'center',
    borderBottom: '1px solid #F4F6F8',
    padding: '14px 8px',
    fontSize: '14px',
    color: '#002E47',
    fontFamily: 'Inter',
  },
  rootTableCell2: {
    backgroundColor: '#fff',
    width: '40%',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    borderBottom: '1px solid #F4F6F8',
    padding: '14px 16px',
  },
  tableBox: {
    width: 20,
    height: 20,
    color: 'var(--mcg-dark, #002E47)',
  },
})

export default styles
